import { useState } from "react"

const useTableQuerySaver = () => {
  const [savedQuery, setSavedQuery] = useState({
    page: null,
    pageSize: null,
    search: null
  })


  const saveQuery = (newQuery) => {
    setSavedQuery(prevQuery => ({ ...prevQuery, ...newQuery }))
  }

  return {
    savedQuery,
    saveQuery
  }
}

export default useTableQuerySaver